const creativeCreations = [
  {
    title: 'Digital Advertising',
    items: [
      'Facebook & social media ad campaigns',
      'Google Display advertising',
      'Programmatic ad creative',
      'A/B tested ad variations'
    ]
  },
  {
    title: 'Web & Landing Pages',
    items: [
      'High-converting landing page design',
      'Product showcase pages',
      'Campaign-specific microsites',
      'Responsive, mobile-optimized layouts'
    ]
  },
  {
    title: 'Brand & Campaign Design',
    items: [
      'Complete brand identity systems',
      'Campaign concepts and creative direction',
      'Marketing collateral and sales materials',
      'Brand guidelines and asset libraries'
    ]
  },
  {
    title: 'Out-of-Home',
    items: [
      'Billboard design',
      'Transit advertising',
      'Signage and environmental graphics',
      'Large-format print design'
    ]
  }
];

const creativeProcessSteps = [
  { number: '01', title: 'Concept Development', text: 'Strategic creative concepts aligned with your goals' },
  { number: '02', title: 'Design & Production', text: 'Professional execution across all media formats' },
  { number: '03', title: 'Media Coordination', text: 'Placement and buying strategy support' },
  { number: '04', title: 'Performance Tracking', text: 'Analytics and optimization for maximum impact' },
  { number: '05', title: 'Multi-Channel Execution', text: 'Consistent campaigns across all touchpoints' }
];

const developmentBuilds = [
  {
    title: 'Financial Systems That Don\'t Flinch',
    items: [
      'Bank-grade payment engines',
      'Cryptocurrency and digital asset platforms',
      'Bitcoin trading systems before they were cool',
      'Real-time transaction networks hardened for abuse, scale, and audits'
    ]
  },
  {
    title: 'Healthcare Platforms That Carried Clinics',
    items: [
      'End-to-end EHR infrastructures',
      'Multi-clinic, multi-state provider networks',
      'Charting, billing, scheduling, and PHI-secure everything',
      'Enterprise practice management built for real clinics'
    ]
  },
  {
    title: 'Enterprise & Government Systems With No Room for Failure',
    items: [
      'Bond and grant management platforms',
      'Construction program oversight systems',
      'District-wide project and financial tracking',
      'Custom CRM, workflow, and operational automation'
    ]
  },
  {
    title: 'Encrypted Communications Before Privacy Was Trendy',
    items: [
      'Encrypted messaging platforms',
      'PGP-driven secure mail systems',
      'Private organizational communication networks'
    ]
  },
  {
    title: 'Emerging Tech Before It Emerged',
    items: [
      'AI and machine-learning integrations',
      'Autonomous and IoT device platforms',
      'Real-time distributed architectures',
      'High-performance systems for edge and hardware-adjacent tech'
    ]
  }
];

const developmentWhyBullets = [
  'We\'re not coasting on nostalgia—we\'re showing the receipts.',
  'Every app, automation, interface, and system we build today is backed by a quarter-century of engineering scars, wins, pivots, late-night saves, and production victories.',
  'You\'re not hiring a dev shop. You\'re bringing in a boutique engineering strike team with experience that can\'t be faked.'
];

const en = {
  layout: {
    title: 'TX Fortress Music',
    description: 'Texas Fortress AI turns ideas into shipped code—quickly and securely.'
  },
  languageSwitcher: {
    en: 'EN',
    es: 'ES',
    ariaLabel: 'Switch language'
  },
  menu: {
    home: 'Home',
    news: 'News',
    development: 'Development',
    creative: 'Creative',
    music: 'Music',
    charity: 'Charity',
    about: 'About'
  },
  legal: {
    openSource: '— Open Source by Contributors —'
  },
  notFound: {
    title: 'Not found',
    description: 'The location you are looking for was not found in the system.',
    goToStart: 'Go to Start'
  },
  home: {
    welcome: 'Welcome.'
  },
  about: {
    title: 'About Soul Extract',
    intro: 'Cerebral. Beautiful. Violent. Soul Extract taps into a wealth of human emotions and experiences to generate a listening space that is as intense and unpredictable as life itself. The highly personal inspiration for Soul Extract’s creations gives every song an invigorating level of creative clarity, and the artist’s willingness to smash through genre barriers puts him at the forefront of modern music.',
    imageAlt: "Josh Mullis's photo",
    second: 'Although Soul Extract’s stylistic approach fits within the broad scope of electronic rock, labels can’t begin to describe the exploratory, borderline progressive nature of the songs themselves. Josh Mullis, the architect behind Soul Extract’s elaborate compositions, brings a deconstructive mindset to his craft, tearing apart genres and fusing their most compelling elements back together to build calculated and highly detailed tracks.',
    albumAlt: 'Soul Extract Circadian Algorithm album',
    lowerParagraphs: [
      'This analytical approach to Soul Extract began to take shape in 2013, and after years spent synthesizing the sounds of metal, electronic, and orchestral music, the artist unleashed his fiery debut album, Circadian Algorithm. Loaded wall-to-wall with emotive vocals and explosive instrumental sections, the album has laid the foundation for a developing career with an upward trajectory.',
      'Mullis’ passion for music began at a young age, and he has traditionally pulled from deeply personal events for his creative stimulus. Finding escape from a family struggles by picking up a guitar as a teenager, Mullis discovered those early creative efforts were able to carry him through unpredictable times. As an adult, a motivating force for his music rests within humanitarian endeavors, as Mullis donates proceeds from Soul Extract to New Day Foster Home (www.newdayfosterhome.com), a charity that supported the health of his adopted daughter at an early age.',
      'For Mullis, music is an indescribable force capable of sparking intense emotion, and this force is the essence of an artist in its purest form. As the project name suggests, Soul Extract is Josh Mullis’ unaltered expression of himself, and his passionate approach to songwriting shines through on every track he produces.'
    ],
    sourceLabel: 'Source:',
    sourceLinkText: 'fixtonline.com/label/artists/soul-extract'
  },
  charity: {
    title: 'Charity Donation',
    intro: 'Music has always been a platform for artists to support and raise awareness to causes near and dear to them. Through their creative outlets countless established and aspiring musicians/artists alike have utilized the powerful tool that is a public platform to fuel societal-consciousness of causes that might otherwise go neglected.',
    familyAlt: "Josh Mullis's family",
    cause: {
      prefix: 'For Soul Extract’s Josh Mullis that cause is the',
      linkLabel: 'New Day Foster Home',
      suffix: ', a non-profit organization based in China that’s been providing “life saving surgeries and a loving home” to orphaned children since late 2000. Mullis’ family became involved with New Day in 2011 when they made the life-changing choice to adopt a child from China, which at the time still held a strictly enforced “one child law”.'
    },
    fosterHomeAlt: 'New Day Foster Home',
    quoteIntro: [
      'For Soul Extract’s Josh Mullis that cause is the New Day Foster Home, a non-profit organization based in China that’s been providing “life saving surgeries and a loving home” to orphaned children since late 2000. Mullis’ family became involved with New Day in 2011 when they made the life-changing choice to adopt a child from China, which at the time still held a strictly enforced “one child law”.',
      'Ansley was born with myelomeningocele, the most severe form of Spina Bifida. This birth defect affects the spine and spinal cord and many children end up incontinent and/or unable to walk. She is now living a happy, normal life thanks to the New Day Foster Home.'
    ],
    enlarging: 'Enlarging their family also broadened the horizons of the Mullis clan and Josh became inspired to direct his craft toward the greater good,',
    quoteTwo: 'The whole experience inspired me to dedicate my music project to this organization any way I can. Whether it be donating partial proceeds or sponsoring a child.',
    albumParagraph: 'With a new album, Circadian Algorithm, out next week (November 13th), the sky is the limit for Soul Extract/Mullis, who credits his humanitarian efforts as a continual source of motivation:',
    quoteThree: 'When I become frustrated with the music creation process, this keeps me going and has created a sense of purpose with this project.',
    involvement: 'If fans of Soul Extract are looking to get involved with the New Day Foster Home, Mullis definitely has some ideas:',
    quoteFour: [
      'For starters, if you’re listening to Circadian Algorithm via streaming outlets or have purchased it, you are helping New Day as partial proceeds are sent directly to them. They also have an awesome Instagram account (@newdaycharities), where they post regularly on fun things they do with the children, surgery updates, etc.',
      'I’d say that’s a good place to start and if your heart pulls you in that direction, they have a donation page here:'
    ],
    fosterLogoAlt: 'New Day Foster Home logo',
    closing: 'We’re proud to support Soul Extract through Texas Fortress AI and to bolster his efforts in making the world a better place, one badass album at a time.',
    sourceLabel: 'Source:',
    sourceLinkText: 'texasfortress.ai'
  },
  music: {
    missing: 'Audio files not found. Add tracks under static/music to populate this page.',
    selectTrack: 'Select any single to launch playback.',
    play: '▶ PLAY',
    pause: '⏸ PAUSE',
    unknownArtist: 'Unknown Artist'
  },
  news: {
    title: 'News',
    seeMore: 'See more at',
    facebookCta: 'facebook.com/soulextract.'
  },
  creative: {
    metaTitle: 'Creative - Texas Fortress AI',
    metaDescription: 'Full-service creative for brands that demand impact—ads, landing pages, brand systems, and campaigns that convert.',
    heroTitle: 'Ideas That Capture Attention',
    heroSubtitle: 'Full-service creative agency for brands that demand impact',
    introTitle: 'Creative That Converts',
    introText: `From concept to campaign, we craft visual experiences that stop the scroll, command attention, and drive results.
We're not just designers—we're strategic partners who understand that great creative serves your business goals.`,
    creationsTitle: 'What We Create',
    strategyTitle: 'Strategy Meets Design',
    strategyText: `Every pixel serves a purpose. We combine creative firepower with data-driven strategy to deliver campaigns that
don't just look good—they perform. Whether you need a complete brand overhaul or a single killer ad, we bring
the same level of craft and strategic thinking.`,
    processTitle: 'End-to-End Campaign Management',
    ctaText: 'Let\'s create something memorable — open chat to start now.',
    creations: creativeCreations,
    processSteps: creativeProcessSteps
  },
  development: {
    metaTitle: 'Development - Texas Fortress AI',
    metaDescription: 'Building tomorrow’s solutions today — secure, production-ready software from AI to infrastructure.',
    heroTitle: 'Building Tomorrow\'s Solutions Today',
    heroSubtitle: '25 years of engineering excellence across every software frontier',
    resumeTitle: 'Our Proven Battle Record',
    resumeParagraphs: [
      'We didn\'t wake up yesterday and decide to build software. We earned our stripes across 25 years of real engineering wars—shipping systems other teams wouldn\'t touch, solving problems bigger shops walked away from, and delivering production platforms before "startup culture" even learned to spell MVP.',
      'This isn\'t a list of what we sell today. This is our resume of impossible things—the proof behind every promise we make now.'
    ],
    buildsTitle: 'What We\'ve Built When It Mattered Most',
    builds: developmentBuilds,
    whyTitle: 'Why This Matters Today',
    whyBullets: developmentWhyBullets,
    cta: 'Ready to build something extraordinary? Start a chat with us.'
  }
};

export default en;
